<template>
  <div>
    <v-card color="grey lighten-4">
      <v-snackbar
        :timeout="timeout"
        :color="color"
        :left="left"
        v-model="snackbar"
        >{{ message }}</v-snackbar
      >
    </v-card>
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <v-select
                    label="Organizer Category"
                    item-text="name"
                    item-value="id"
                    :items="[
                      { id: 'Organization', name: 'Organization' },
                      { id: 'Individual', name: 'Individual' },
                    ]"
                    v-model="formSchema.org_type"
                    :rules="[(v) => !!v || 'Organizer Category is required']"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <v-select
                    label="Organizer Type"
                    item-text="name"
                    item-value="id"
                    :items="[
                      { id: 'Local', name: 'Local' },
                      { id: 'Foreign', name: 'Foreign' },
                    ]"
                    v-model="formSchema.org_origin"
                    :rules="[(v) => !!v || 'Organizer Type is required']"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label=" Organization / Individual name"
                    v-model="formSchema.name"
                    :rules="[(v) => !!v || 'Field is required']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Address"
                    v-model="formSchema.address"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Location"
                    v-model="formSchema.location"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Contact Person 1"
                    v-model="formSchema.contact_person_1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Phone Number"
                    v-model="formSchema.contact_phone_1"
                    :rules="[rules.phoneNumber]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Email"
                    v-model="formSchema.email_1"
                    :rules="[rules.email]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Contact Person 2"
                    v-model="formSchema.contact_person_2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Phone Number"
                    v-model="formSchema.contact_phone_2"
                    :rules="[rules.phoneNumber]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Email"
                    v-model="formSchema.email_2"
                    :rules="[rules.email]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-checkbox
                      v-model="formSchema.active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>     
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.native="validateBeforeSubmit"
              :disabled="!valid"
              >{{ buttonTitle }}</v-btn
            >
            <v-btn color="error" @click.native="reset()">Reset</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");

import { preFix } from "../../../vuex/api";
import Axios from "axios";
export default {
  props: ["formSchema"],
  data: () => ({
    valid: true,
    dialog: false,
    dialogEditForm: false,
    isActiveVal: 1,
    search: "",
    totalItems: 0,
    loading: true,

    pagination: {
      sortBy: "id",
      descending: true,
    },

    selected: [],
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "User Type", align: "left", value: "type_id" },
      { text: "Email", value: "email" },
    ],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    select: null,
    instituteList: [],

    typelist: [],

    rules: {
      email: (v) => {
        // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // return pattern.test(value) || "Enter valid e-mail.";
        if (v && v.length > 0) {
          return (
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "E-mail must be valid"
          );
        } else {
          return true;
        }
      },
      phoneNumber: (v) => {
        // const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
        // return pattern.test(value) || "Enter valid phone no.";
        if (v && v.length > 0) {
          return (
            /(\+)?^[+0-9\(\)_.-]*$/.test(v) ||
            "Phone no. must be valid"
          );
        } else {
          return true;
        }
      },
    },
    instituteShow: true,
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Training Organizer Information"
        : "Add Training Organizer Information";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
  },

  created() {},

  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "training_organizer")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "training_organizer")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
              };
              this.close(actionData);
            });
        }
      }
    },
    close: function(message) {
      if (message.status == 1) {
        this.$refs.form.reset();
      }
      this.$emit("reloadData", message);
    },

    reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
  },

  watch: {},

  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/training/training_organizer_info/_organizer_form.vue